// extracted by mini-css-extract-plugin
module.exports = {"link":"button-module--link--20i0b","black":"button-module--black--2IZV2"};